// @ts-check
// Ordem das views no seletor (doc 06, seção 3.3): arrastar uma view para o lugar de outra grava `position` igual ao
// índice, só nas views cuja posição mudou, como o DraggableList do Twenty. Módulo puro.

/**
 * @param {Array<{ id: string, position?: number }>} views views de uma seção, na ordem exibida
 * @param {string} draggedId view arrastada
 * @param {string} targetId view sobre a qual ela foi solta (ela ocupa o lugar desta)
 * @returns {Array<{ id: string, position: number }>} posições novas, só das views que mudaram
 */
export function computeViewPositionChanges(views, draggedId, targetId) {
  const fromIndex = views.findIndex((view) => view.id === draggedId);
  const toIndex = views.findIndex((view) => view.id === targetId);
  if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return [];
  const ordered = [...views];
  const [moved] = ordered.splice(fromIndex, 1);
  ordered.splice(toIndex, 0, moved);
  return ordered
    .map((view, index) => ({ id: view.id, position: index, previous: view.position }))
    .filter((change) => change.previous !== change.position)
    .map(({ id, position }) => ({ id, position }));
}

/**
 * Move uma view uma casa para cima ou para baixo (teclado e leitores de tela, sem arrastar).
 * @param {Array<{ id: string, position?: number }>} views @param {string} viewId @param {-1 | 1} offset
 */
export function computeViewMoveChanges(views, viewId, offset) {
  const index = views.findIndex((view) => view.id === viewId);
  const target = views[index + offset];
  return index < 0 || !target ? [] : computeViewPositionChanges(views, viewId, target.id);
}
